import { apiClient } from '../utils/api-client';
import type { Maintainer } from '../types/maintainer';
import type { CragReport } from '../types/crag-report';

interface MaintainerResponse {
  data: {
    id: string;
    type: 'maintainer';
    attributes: Maintainer;
  };
  /** Every published report across the crags they look after. */
  included?: { id: string; type: 'crag_report'; attributes: CragReport }[];
}

/** A maintainer's page: who they are, plus the reports that reach them. */
export interface MaintainerProfile {
  maintainer: Maintainer;
  reports: CragReport[];
}

class MaintainersService {
  async getBySlug(slug: string): Promise<MaintainerProfile> {
    const response = await apiClient.get(`/api/maintainers/${slug}`);

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Maintainer not found');
      }
      throw new Error('Failed to fetch maintainer');
    }

    const data: MaintainerResponse = await response.json();
    return {
      maintainer: data.data.attributes,
      reports: (data.included ?? []).map((item) => item.attributes),
    };
  }
}

export const maintainersService = new MaintainersService();
